import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47029ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-button" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EllipsisLoader = _resolveComponent("EllipsisLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.disable ? 'ui-button__disable' : 'ui-button__element'),
      style: _normalizeStyle(_ctx.disable ? _ctx.styleDisable : _ctx.style)
    }, [
      _createElementVNode("div", {
        class: "ui-button__element_label",
        style: _normalizeStyle({ fontWeight: _ctx.fontWeight, fontSize: _ctx.fontSize })
      }, [
        (!_ctx.disable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        (_ctx.disable)
          ? (_openBlock(), _createBlock(_component_EllipsisLoader, { key: 1 }))
          : _createCommentVNode("", true)
      ], 4)
    ], 6)
  ]))
}